import axios from "axios";

// const API_ADMIN = "http://127.0.0.1:8000/api/admin";
// const API_GESTIONNAIRE = "http://127.0.0.1:8000/api/gestionnaire";
// const API_ADMIN = "http://192.168.122.63:8000/api/admin";
// const API_GESTIONNAIRE = "http://192.168.122.63:8000/api/gestionnaire";


const API_ADMIN = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;

export default class NomDomaineService {

    static getApiUrl(role) {
        return role === "admin" ? API_ADMIN : API_GESTIONNAIRE;
    }

    static getAuthToken() {
        return localStorage.getItem('token');
    }
    static async getAllNomsDomaine(role, params = {}) {
        const token = this.getAuthToken();
        const apiUrl = this.getApiUrl(role);
        try {
            const response = await axios.get(`${apiUrl}/domaine`, {
                headers: { Authorization: `Bearer ${token}` },
                params,
            });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la récupération des noms de domaine", error);
            throw error;
        }
    }

    static async getNomDomaineById(role, id) {
        const token = this.getAuthToken();
        const apiUrl = this.getApiUrl(role);

        let cleanId = id;
        if (typeof cleanId === 'string') {
            if (cleanId.includes('|')) {
                cleanId = cleanId.split('|')[0];
            }
            cleanId = cleanId.replace(/[^0-9]/g, '');
        }

        if (!cleanId || cleanId === '') {
            throw new Error('ID invalide');
        }

        try {
            const response = await axios.get(`${apiUrl}/domaine/${cleanId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });


            if (response.data && response.data.data) {
                return response.data.data;
            }
            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la récupération du nom de domaine ${cleanId}`, error);
            throw error;
        }
    }


    static async createNomDomaine(role, nomDomaineData) {
        const token = this.getAuthToken();
        const apiUrl = this.getApiUrl(role);
        try {
            const response = await axios.post(`${apiUrl}/domaine`, nomDomaineData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la création du nom de domaine", error);
            throw error;
        }
    }

    static async updateNomDomaine(role, id, nomDomaineData) {
        const token = this.getAuthToken();
        const apiUrl = this.getApiUrl(role);
        try {
            const response = await axios.put(`${apiUrl}/domaine/${id}`, nomDomaineData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la mise à jour du nom de domaine", error);
            throw error;
        }
    }

    static async deleteNomDomaine(role, id) {
        const token = this.getAuthToken();
        const apiUrl = this.getApiUrl(role);
        try {
            const response = await axios.delete(`${apiUrl}/domaine/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la suppression du nom de domaine", error);
            throw error;
        }
    }

    static async getComptesComptables(role, societeId) {
        const token = this.getAuthToken();
        const apiUrl = this.getApiUrl(role);
        try {
            const response = await axios.get(`${apiUrl}/comptes-comptables/by-societe`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { societe_id: societeId },
            });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la récupération du plan comptable", error.response?.data || error.message);
            throw error;
        }
    }


}
